module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Union-18189b3130d45433caab2bd81f4e1c8a.svg";